<!-- @slideInOut -->
<div class="bottom-menu" *ngIf="isH5 && !hide && active && (layout.h5BottomMenuHide$ | async) === false">
  <div
    class="menu-item onact96"
    (click)="leftBarStatus ? layout.leftMenuState$.next(false) : layout.leftMenuState$.next(true)"
    [style.order]="1"
  >
    <span
      class="item-icon icon-bottom-menu2"
      [ngStyle]="{
        '--show-dot': showMenuDot() ? 'block' : 'none',
      }"
    ></span>
    <span class="item-txt">{{ 'menu' | translate }}</span>
  </div>
  <div
    class="menu-item onact96"
    [routerLink]="[]"
    [relativeTo]="route"
    fragment="wallet"
    (click)="layout.leftMenuState$.next(false)"
    [style.order]="3"
  >
    <div class="wallet-btn-box">
      <div class="wallet-btn">
        <div class="wallet-btn-icon">
          <i class="item-icon icon-top-wallet"></i>
        </div>
      </div>
    </div>
    <span class="item-icon"></span>
    <span class="item-txt bold">{{ 'wallet' | translate }}</span>
  </div>

  <ng-container *ngFor="let item of bottomMenuItem">
    <div
      class="menu-item onact96"
      [routerLink]="item.routerLink"
      (click)="layout.leftMenuState$.next(false)"
      routerLinkActive="active"
      [style.order]="item.order"
    >
      <ng-container *ngIf="isBottomMenuReady">
        <img class="inactive-img" lazy="loading" [src]="item.icon" />
        <img class="active-img" lazy="loading" [src]="item.menuIcon" />
        <span class="item-txt">{{ item.menuItemName || '' }}</span>
      </ng-container>
      <ng-container *ngIf="!isBottomMenuReady">
        <p class="img-loading skeleton-loading"></p>
        <p class="item-txt item-txt-loading skeleton-loading"></p>
      </ng-container>
    </div>
  </ng-container>
</div>
